import { isEqual } from "lodash";
import { createSelectorCreator, defaultMemoize } from "reselect";

// This is a "selector creator" that uses deep equality instead of reference equality:
export const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  isEqual
);
